import React, { Children } from "react";

import errorillustrator from "../../assets/images/errorillustrator.svg";
import welcomepic from "../../assets/images/wellcomepic.svg";

// example desktop

// <Hint
// response={"desktop"}
// hintImage={true}
// title={"راهنما"}
// entry={"flex justify-start items-center"}
// imagestyle={"desktop"}
// image={"w-[40%]"}
// text={"w-[60%]"}
// >
// <ul className=" ">
//   <li className="text-title-sm-regular mb-5">
//     وارد کردن اطلاعات شخصی و بازگذاری مدارک برای پیمودن مراحل بعدی
//     الزامیست و تمام این اطلاعات بصورت محرمانه نزد وندا‌پرداخت نگه داشته
//     می‌شود و پرداخت‌کننده، دسترسی به این اطلاعات ندارد!
//   </li>
//   <li className="text-title-sm-regular">
//     طبق اعلامیه شاپرک مالک شماره تلفن همراه می‌بایست با دارنده کدملی و
//     شماره‌شبا بانکی مطابقت داشته باشد.
//   </li>
// </ul>
// </Hint>

// example mobile

{
  /* <Hint
response={"mobile"}
hintImage={true}
title={"خوش آمدید"}
entry={"flex justify-center items-center"}
>
<p className="flex justify-center items-center mb-4">
  {" "}
  جهت دریافت درگاه پرداخت و دیگر خدمات ما وارد ناحیه کاربری شوید و
  اطلاعات خود را تکمیل کنید!
</p>
<div onClick={hanndleAccount}>
<Buttons
  btnStyleparam={"mainbutton"}
  fontsize={"dashboard"}
  bgcolor={"primary"}
  txtcolor={"primary"}
  children={" ورود به ناحیه کاربری"}
  lefticon={false}
  righticon={false}
  borders={"secondary"}
  bRadius={"xl"}
/>
</div>
</Hint> */
}

const Hint = ({
  hintStyle,
  response,
  hintImage,
  children,
  title,
  entry,
  imagestyle,
  image,
  text,
  imagetype,
}) => {
  let breakpoint = "";
  switch (response) {
    case "mobile":
      breakpoint = "flex flex-col bg-neutral-00 gap-2 rounded-2xl p-1";
      break;
    case "desktop":
      breakpoint = "flex  flex-row-reverse bg-neutral-00 gap-2 rounded-2xl p-1";
      break;

    default:
      break;
  }

  let imageclassname = "";
  switch (imagestyle) {
    case "desktop":
      imageclassname = "object-cover object-top h-56 w-full";
      break;

    default:
      break;
  }

  return (
    <>
      {hintStyle === "entry" ? (
        <div className={`${breakpoint}`}>
          <div className={`${image}`}>
            {hintImage == true ? (
              <img
                className="object-cover object-top h-56 w-full rounded-2xl "
                // className={imageclassname}
                src={welcomepic}
                alt="wellcome-pic"
              ></img>
            ) : null}
          </div>
          <div className={`${text}`}>
            <h1 className={`mt-4 mb-[10px] text-title-xl-semibold ${entry}`}>{title}</h1>
            <div>{children}</div>
          </div>
        </div>
      ) : null}
      {hintStyle === "error" ? (
        <div className={`${breakpoint}`}>
          <div className={`${image}`}>
            {hintImage == true ? (
              <img className={`${imageclassname}`} src={errorillustrator} alt="wellcome-pic"></img>
            ) : null}
          </div>
          <div className={`${text}`}>
            <h1 className={`mt-4 mb-[10px] text-title-xl-semibold ${entry}`}>{title}</h1>
            <div>{children}</div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Hint;
